const AlertTriangleFilled = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      width={width || "20"}
      height={height || "20"}
    >
      <g id="alert-triangle">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          fill={color || "#EBBD07"}
          d="M10.6771 1.38986C10.246 1.19817 9.75387 1.19817 9.32277 1.38986C8.98983 1.5379 8.77355 1.79867 8.62305 2.01115C8.47508 2.22006 8.31666 2.49374 8.14243 2.79474L1.25313 14.6944C1.07821 14.9965 0.919248 15.271 0.811464 15.504C0.701923 15.7408 0.583086 16.0591 0.62096 16.4224C0.669969 16.8924 0.916253 17.3196 1.29852 17.5975C1.59393 17.8123 1.92892 17.869 2.18872 17.8928C2.44435 17.9163 2.76156 17.9162 3.11063 17.9162H16.8892C17.2383 17.9162 17.5555 17.9163 17.8111 17.8928C18.0709 17.869 18.4059 17.8123 18.7014 17.5975C19.0836 17.3196 19.3299 16.8924 19.3789 16.4224C19.4168 16.0591 19.2979 15.7408 19.1884 15.504C19.0806 15.2711 18.9217 14.9966 18.7468 14.6945L11.8574 2.79471C11.6832 2.49373 11.5248 2.22005 11.3768 2.01115C11.2263 1.79867 11.01 1.5379 10.6771 1.38986ZM10.8333 7.49955C10.8333 7.03932 10.4602 6.66622 9.99996 6.66622C9.53972 6.66622 9.16663 7.03932 9.16663 7.49955V10.8329C9.16663 11.2931 9.53972 11.6662 9.99996 11.6662C10.4602 11.6662 10.8333 11.2931 10.8333 10.8329V7.49955ZM9.99996 13.3329C9.53972 13.3329 9.16663 13.706 9.16663 14.1662C9.16663 14.6265 9.53972 14.9996 9.99996 14.9996H10.0083C10.4685 14.9996 10.8416 14.6265 10.8416 14.1662C10.8416 13.706 10.4685 13.3329 10.0083 13.3329H9.99996Z"
        />
      </g>
    </svg>
  );
};

export default AlertTriangleFilled;
